const base = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Warm the Render backend on app load so cold start finishes
 * BEFORE the user submits any form.
 *
 * - Timeout: 100s (Render cold start can be ~50–90s)
 * - Tries both /health and /api/health
 * - Only fires once per session (sessionStorage flag)
 */
export function warmBackend() {
  if (typeof window === 'undefined') return;

  // Only ping once per browser session.
  if (sessionStorage.getItem('backend_warmed')) return;
  sessionStorage.setItem('backend_warmed', '1');

  const root = base.endsWith('/api') ? base.replace(/\/api$/, '') : base;
  const urls = [`${root}/health`, `${root}/api/health`];

  urls.forEach((url) => {
    const controller = new AbortController();
    const t = window.setTimeout(() => controller.abort(), 100_000);

    fetch(url, {
      method: 'GET',
      credentials: 'omit',
      signal: controller.signal,
    })
      .then(() => {
        // best-effort warm-up; keep this out of the critical path
        // eslint-disable-next-line no-console
        console.log('[warmBackend] Server is warm ✓');
      })
      .catch(() => {
        // Silent — best-effort.
      })
      .finally(() => window.clearTimeout(t));
  });
}

